import merge from 'lodash/merge';
import defaultOptions from '@atlassian/jira-common-constants/src/fetch-default-options';
import { FetchError } from '@atlassian/jira-fetch';

const X_ALAST_CHANGED_TIME_HEADER = 'x-alast-changed-time';

const emptyHeaders = {};
const defaultHeaders = { headers: emptyHeaders };

// shouldUpdateChangedSinceHeader prop is used in useDeleteColumn where we
// poll the workflows api to check that the data has been updated.
// If updated, this function is called again in fetchBoardData and we want to update state.
// for this mechanism to work we do not want to override 'x-aif-changed-since'

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const getBoardDataWithMultipleWorkflows = async (
	projectId: string,
	shouldUpdateChangedSinceHeader = true,
) => {
	try {
		const url = `/rest/board-api/1/board/${projectId}/workflows?excludeLabels=true`;
		let res;
		if (defaultHeaders.headers === emptyHeaders) {
			// Don't fetch with empty headers. It seems to be triggering 304 from previous request
			res = await fetch(url);
		} else {
			res = await fetch(url, merge(defaultOptions, defaultHeaders));
		}
		if (shouldUpdateChangedSinceHeader && res.ok && res.headers.get(X_ALAST_CHANGED_TIME_HEADER)) {
			defaultHeaders.headers = {
				'x-aif-changed-since': res.headers.get(X_ALAST_CHANGED_TIME_HEADER),
			};
		}
		return res;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		throw new FetchError(e);
	}
};

// Resets last changed module scoped time variable, causing the following call to load board data regardless of whether it has changed or not
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const resetLastChangedHeader = () => {
	defaultHeaders.headers = emptyHeaders;
};
